import type {RouteRecordRaw} from 'vue-router';
import useAnalyticsDashboards from '@/composables/useAnalyticsDashboards';

export const analyticsRoutes: RouteRecordRaw[] = [
  {
    path: '/analytics',
    meta: {
      permissions: ['getCumulioToken'],
      title: (t) => t('analytics.title'),
    },
    children: [
      {
        name: 'insights',
        path: '',
        redirect: {
          name: 'analytics-dashboard',
          params: {
            category: 'shipments',
          },
        },
      },
      {
        name: 'analytics-dashboard',
        path: ':category',
        props: true,
        component: () => import('@/views/Analytics/Analytics.vue'),
        beforeEnter: async (to) => {
          const {activeAnalyticsDashboards, getAnalyticsDashboardCredentials} = useAnalyticsDashboards();
          await getAnalyticsDashboardCredentials();
          const hasCategory = activeAnalyticsDashboards.value.some(
            (dashboard) => dashboard.category === to.params.category,
          );

          if (hasCategory) {
            return true;
          }

          // TODO - FE-1730 - add notification that the category is not available

          // if no category is found, redirect to the first available category
          if (activeAnalyticsDashboards.value.length) {
            return {
              name: 'analytics-dashboard',
              params: {
                category: activeAnalyticsDashboards.value[0].category,
              },
            };
          }

          // if there is no category redirect to the dashboard
          return {
            name: 'dashboard',
          };
        },
      },
    ],
  },
];
